import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelList from './ModelList';
import { getModelManager, getUserProfileWidget, getCurrentTimezone, getUserOrgModelCategoryType } from '../../selectors/index';
import { getModelsThunk, setCurrentPage, setPageFilter, setFilteredDataThunk, modelCleanUpThunk } from '../../actions/model';

const mapStateToProps = state => {
  return {
    modelManager: getModelManager(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    userModelCategories: getUserOrgModelCategoryType(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getModels: (offset, limit, filter, organisationId, modelCategoryId) => getModelsThunk(offset, limit, filter, 'MODELS_TAB', organisationId, modelCategoryId),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      setFilterData: filteredData => setFilteredDataThunk(filteredData),
      modelCleanUp: initialData => modelCleanUpThunk(initialData)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelList);
